// extracted by mini-css-extract-plugin
var _1 = "IGNH3";
var _2 = "QUGjY";
var _3 = "VdKFu";
var _4 = "W0WAz";
var _5 = "rqjHN";
var _6 = "JO3qP";
var _7 = "KKj_V";
var _8 = "j3XzV";
var _9 = "bDqMT";
var _a = "q3CzD";
export { _1 as "base", _2 as "content", _3 as "error", _4 as "icon", _5 as "info", _6 as "simple", _7 as "success", _8 as "theme-dark", _9 as "theme-light", _a as "warning" }
